import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form } from 'antd';
import './formFooter.scss';

interface FormFooterProps {
    name?: string;
    onCancel: () => void;
    className?: string;
    disabled?: boolean;
    okText?: string;
}

const FormFooterComponent = ({ name, onCancel, className, disabled, okText }: FormFooterProps) => {
    const { t } = useTranslation();
    return (
        <Form.Item name={name} className={className}>
            <div>
                <Button onClick={onCancel} className='cancelFooterBtn'>{t('general.cancel')}</Button>
                <Button type='primary' htmlType='submit' className='okFooterBtn' disabled={disabled}>
                    {okText ?? t('general.ok')}
                </Button>
            </div>
        </Form.Item>
    );
};

export default FormFooterComponent;
